import Swiper from 'swiper';
import { Autoplay, Pagination } from 'swiper/modules';

class HomeHeading {
  constructor() {
    this._init();
  }

  _init() {
    new Swiper('.home-heading__swiper', {
      modules: [Pagination, Autoplay],
      direction: 'horizontal',
      slidesPerView: 1,
      spaceBetween: 0,
      grabCursor: true,
      preventInteractionOnTransition: true,
      loop: true,
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      autoplay: {
        delay: 5000,
        disableOnInteraction: true,
      },
    });
  }
}

export const homeHeading = new HomeHeading();
